import { Link } from 'react-router-dom';
import styles from './Header.module.css';
import { useAuth } from "../../context/AuthContext";

const Header = () => {
  const { user, logout } = useAuth();
  return (
    <header className={styles.header}>
        <div className={styles.info}>
          <span className={styles.user}>Вы увiйшли як: <br />
            Користувач: <strong>{user?.username}</strong> <br />
            Роль: <strong>{user?.role}</strong></span>
        </div>
      <div className={styles.actions}>
        {user?.role === 'admin' && (
            <Link to="/new" className={styles.button}>Створити оренду</Link>
        )}
        {user?.role === 'admin' && (
          <Link to="/" className={styles.button}>Оренди</Link>
        )}
        {user?.role === 'admin' && (
            <Link to="/reports" className={styles.button}>Звiти</Link>
        )}

        <button onClick={logout} className={`${styles.button} ${styles.logout}`}>
          Выйти
        </button>
      </div>
    </header>
  );
};

export default Header;